import { ShoppingCartItemClientMeInsert } from "../../domain/ShoppingCartSlice/ShoppingCartItemClientMeInsert";
import { ShoppingCartItemUpdateBase } from "../../domain/ShoppingCartSlice/ShoppingCartItemUpdateBase";
import ApiWrapperAuthenticated from "../Common/ApiWrapperAuthenticated";
import { ShoppingCartItemDeleteBase } from "../../domain/ShoppingCartSlice/ShoppingCartItemDeleteBase";

export class ShoppingCartItemsClientMeRepository 
    extends ApiWrapperAuthenticated<void, ShoppingCartItemClientMeInsert, ShoppingCartItemUpdateBase, ShoppingCartItemDeleteBase> {
    constructor() {
        super('clients/me/shopping-cart-items/');
    }

    async countItems(): Promise<number | null> {
        return await this.getOneAuthenticatedCustom({ url: `count` });
    }
}
